module.exports = __webpack_public_path__ + "static/prototype-7a481fd167561d79430fc159a42f2928.jpg";